import axios from "../../../axios"

export default {
  fetch() {
    return axios.post('', {
      query: `
        query {
          roles {
            id,
            name,
            name_pt_br
          }
        }
      `
    })
  }
}
